module.exports = __webpack_public_path__ + "static/assets/a26d6d4210e920f050b70f022b91937f.svg";